<template>
  <div class="home">
    <ul>
      <li v-for="item in overview" :key="item.slug">
        <router-link :to="{ name: item.slug, params: { lang: 'de' } }">
          <div class="crop">
            <img :src="getImgUrl(item.image)" v-bind:alt="item.image" />
          </div>
          <span v-html="item.title" />
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import overview from "../data/overview.json";
export default {
  name: "Home",
  data() {
    return {
      overview
    };
  },
  components: {},
  methods: {
    getImgUrl(pic) {
      return require("../assets/" + pic);
    }
  }
};
</script>
<style lang="scss">
.crop {
  width: 200px;
  height: 150px;
  overflow: hidden;
  img {
    width: 200px;
    height: 150px;
    //  height: 300px;
    //  margin: -75px 0 0 -100px;
  }
}
</style>
